"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Program = void 0;
var create_entity_1 = require("../../utils/create-entity");
var graphql_1 = require("../../utils/graphql");
var components_1 = require("../../components");
var program_details_layout_1 = require("./program-details-layout");
var program_card_1 = require("./program-card");
var program_details_banner_1 = require("../../components/entities/program-details-banner");
exports.Program = {
  name: 'Program',
  useConversation: true,
  useFollowers: true,
  useModerators: true,
  useConnections: true,
  canEmbed: true,
  autoRoutes: ['details', 'list', 'update', 'create'],
  usePlatformActivity: true,
  useSlices: true,
  icon: function () {
    return components_1.Icons.Entities.PageLayout;
  },
  list: {
    queryFields: (0, graphql_1.graphql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      banner { id name slug title description { text } alternateText openGraph { id image { id url } } }\n      description { id text html plainTruncated: plain(truncate: { words: 50 }) plain  }\n      isCurrentUserParticipating\n      presenters { ...EntityValueFields }\n      providers { ...EntityValueFields }\n      moderators { ...EntityValueFields }\n      courses { \n        isCurrentUserParticipating\n        ...EntityValueFields \n        startDate\n      }\n      participants { ...EntityValueFields }\n    "], ["\n      banner { id name slug title description { text } alternateText openGraph { id image { id url } } }\n      description { id text html plainTruncated: plain(truncate: { words: 50 }) plain  }\n      isCurrentUserParticipating\n      presenters { ...EntityValueFields }\n      providers { ...EntityValueFields }\n      moderators { ...EntityValueFields }\n      courses { \n        isCurrentUserParticipating\n        ...EntityValueFields \n        startDate\n      }\n      participants { ...EntityValueFields }\n    "])))
  },
  components: {
    card: program_card_1.ProgramCard,
    details: program_details_layout_1.ProgramDetailsLayout,
    banner: program_details_banner_1.ProgramDetailsBanner
  },
  form: {
    fieldsMemoize: false,
    modal: {
      fill: true
    },
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      banner: {
        type: 'banner'
      },
      description: {
        type: 'description'
      },
      courses: {
        type: 'linkedMultiple',
        entityTypeName: 'Course',
        label: 'Courses',
        description: 'Which {{COURSES}} form the curriculum of this {{PROGRAM}}?'
      },
      providers: {
        type: 'linkedMultiple',
        entityTypeName: 'Organisation',
        label: 'Providers',
        description: 'Which organisations are providing this {{PROGRAM}}?'
      }
    })
  },
  details: {
    queryFields: (0, graphql_1.graphql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      id\n      name\n      slug\n      isCurrentUserParticipating\n      description { \n        id text html \n        embeds { ...EntityValueFields } \n      }\n      presenters { ...EntityValueFields }\n      providers { ...EntityValueFields }\n      participants { ...EntityValueFields }\n      courses { \n        ...EntityValueFields \n        startDate\n        badge\n        lessons { id name }\n      }\n      moderators { ...EntityValueFields }\n    "], ["\n      id\n      name\n      slug\n      isCurrentUserParticipating\n      description { \n        id text html \n        embeds { ...EntityValueFields } \n      }\n      presenters { ...EntityValueFields }\n      providers { ...EntityValueFields }\n      participants { ...EntityValueFields }\n      courses { \n        ...EntityValueFields \n        startDate\n        badge\n        lessons { id name }\n      }\n      moderators { ...EntityValueFields }\n    "])))
  }
};
var templateObject_1, templateObject_2;